enum SDSA2AInboundStatuses {
  'airport-preslot' = 1,
  'processing' = 2,
  'driver-preslot' = 3,
  'driver' = 4,
  'complete' = 5
}

export default SDSA2AInboundStatuses;



// WEBPACK FOOTER //
// ./src/enum/SDS-A2A-inbound-status.enum.ts